import store from "@/store";
import { get_storage } from "@/utils/util.js";

//  收藏
const favoritesFn = (isAdd, id, favoriteId, url) => {
  //  如果已收藏，则显示取消收藏
  if (isAdd) {
    store.state.vModal.showType = "addFavorites";
  } else {
    //  如果没有收藏，先判断是否已登录
    let isLogin = get_storage("user_login_sucs");
    if (isLogin) {
      store.state.vModal.showType = "addFavorites";
    } else {
      store.state.vModal.showType = "loginIn";
    }
  }

  store.state.favorites.pictureId = [id];
  store.state.favorites.pictureUrl = url;
  store.state.favorites.currentPictureFavorite = isAdd;
  store.state.favorites.currentPictureFavoriteId = favoriteId;
};

export { favoritesFn };
